"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconActionMessage = function IconActionMessage(_ref) {
  var className = _ref.className,
      color = _ref.color,
      size = _ref.size;
  return /*#__PURE__*/_react.default.createElement("svg", {
    id: "icons",
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 50 50"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M25 28L8.17999 13H41.82L25 28Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M42 16.96V37H8V16.96L25 32.14L42 16.96Z",
    fill: color
  }));
};

IconActionMessage.defaultProps = {
  color: 'black',
  size: 30
};
IconActionMessage.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconActionMessage;
exports.default = _default;